/* ==========================================================================
   RasCommerce — UI behaviour

   Delegated handlers for controls the theme renders dynamically (cart drawer,
   quick view) and re-initialisation of the template's jQuery widgets when the
   theme editor swaps a section in.
   ========================================================================== */
(function () {
  'use strict';

  var RC = (window.RC = window.RC || {});

  /* ------------------------------------------------------- Quantity inputs

     All quantity controls in this theme use [data-rc-qty] rather than the
     template's .minus-btn/.plus-btn classes, so main.js never double-binds
     them and every change fires a real `change` event.
  */

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-rc-qty]');
    if (!button) return;

    event.preventDefault();

    var wrapper = button.closest('.wg-quantity, [data-rc-qty-wrap]');
    if (!wrapper) return;

    var input = wrapper.querySelector('input[type="number"], input[name="quantity"], .quantity-product, input[name="number"]');
    if (!input) return;

    var step = parseInt(input.step, 10) || 1;
    var min = input.min !== '' ? parseInt(input.min, 10) : 1;
    var max = input.max !== '' ? parseInt(input.max, 10) : Infinity;
    var current = parseInt(input.value, 10);
    if (isNaN(current)) current = min;

    var next = button.dataset.rcQty === 'plus' ? current + step : current - step;
    next = Math.max(min, Math.min(max, next));

    if (next === current) return;

    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Guard typed values.
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('[data-rc-qty-input]')) return;

    var min = input.min !== '' ? parseInt(input.min, 10) : 1;
    var max = input.max !== '' ? parseInt(input.max, 10) : Infinity;
    var value = parseInt(input.value, 10);

    if (isNaN(value) || value < min) value = min;
    if (value > max) value = max;

    input.value = value;
  });

  /* --------------------------------------------------- Product card swatch

     Swapping the card image on swatch hover. Bound with delegation so cards
     rendered by filtering, pagination or quick view keep working.
  */

  function applySwatch(swatch) {
    var card = swatch.closest('.card-product');
    if (!card) return;

    var image = swatch.querySelector('img');
    var target = card.querySelector('.img-product');
    if (!image || !target) return;

    var src = image.getAttribute('data-src') || image.getAttribute('src');
    if (!src) return;

    target.setAttribute('src', src);
    target.setAttribute('data-src', src);
    target.removeAttribute('srcset');
    target.removeAttribute('data-srcset');

    card.querySelectorAll('.color-swatch.active').forEach(function (el) {
      el.classList.remove('active');
    });
    swatch.classList.add('active');
  }

  document.addEventListener('mouseover', function (event) {
    var swatch = event.target.closest('.list-color-item.color-swatch');
    if (swatch) applySwatch(swatch);
  });

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('.list-color-item.color-swatch');
    if (swatch) {
      event.preventDefault();
      applySwatch(swatch);
    }
  });

  /* ------------------------------------------------------ Accordion / tabs

     Delegated so dynamically inserted content (product tabs in quick view,
     footer columns on mobile) behaves the same as server-rendered content.
  */

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-rc-accordion-toggle]');
    if (!toggle) return;

    event.preventDefault();
    var item = toggle.closest('[data-rc-accordion-item]');
    if (!item) return;

    var content = item.querySelector('[data-rc-accordion-content]');
    var isOpen = item.classList.contains('is-open');
    var group = toggle.closest('[data-rc-accordion]');

    if (group && group.dataset.rcAccordion === 'single' && !isOpen) {
      group.querySelectorAll('[data-rc-accordion-item].is-open').forEach(function (other) {
        other.classList.remove('is-open');
        var otherContent = other.querySelector('[data-rc-accordion-content]');
        if (otherContent) otherContent.style.maxHeight = null;
        var otherToggle = other.querySelector('[data-rc-accordion-toggle]');
        if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
      });
    }

    item.classList.toggle('is-open', !isOpen);
    toggle.setAttribute('aria-expanded', String(!isOpen));

    if (content) {
      content.style.maxHeight = isOpen ? null : content.scrollHeight + 'px';
    }
  });

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-rc-tab]');
    if (!tab) return;

    event.preventDefault();
    var group = tab.closest('[data-rc-tabs]');
    if (!group) return;

    var targetId = tab.dataset.rcTab;

    group.querySelectorAll('[data-rc-tab]').forEach(function (el) {
      var active = el === tab;
      el.classList.toggle('active', active);
      el.setAttribute('aria-selected', String(active));
    });

    group.querySelectorAll('[data-rc-tab-panel]').forEach(function (panel) {
      panel.classList.toggle('active', panel.dataset.rcTabPanel === targetId);
    });
  });

  /* --------------------------------------------------------- Sticky header

     main.js slides the header out of view on scroll-down. The CSS pins it, and
     this adds the solid background once the page has scrolled away from the top.
  */

  (function stickyHeader() {
    var header = document.querySelector('#header.header-sticky');
    if (!header) return;

    /* Stick the section wrapper, not the header: a sticky header can only
       stick within its own Shopify section wrapper, which is header-height. */
    var wrapper = header.closest('.shopify-section') || header.parentElement;
    if (!wrapper) return;
    wrapper.classList.add('rc-sticky-wrapper');

    var ticking = false;

    function update() {
      wrapper.classList.toggle('is-stuck', window.scrollY > 10);
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );

    update();
  })();

  /* -------------------------------------------------------- Editor re-init

     main.js binds its widgets once at DOM-ready. When the editor replaces a
     section we re-run the pieces that matter for the new markup only.
  */

  RC.onEditorSectionLoad(function (scope) {
    if (window.WOW) {
      scope.querySelectorAll('.wow').forEach(function (el) {
        el.style.visibility = 'visible';
        el.classList.add('animated');
      });
    }

    // Countdown timers ship as a global initialiser in count-down.js.
    if (typeof window.initCountdown === 'function') {
      window.initCountdown(scope);
    }

    // Bootstrap selects inside a fresh section.
    if (window.jQuery && window.jQuery.fn.selectpicker) {
      window.jQuery(scope).find('.image-select').selectpicker('refresh');
    }
  });
})();
